import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {
    mediaLaptop,
    mediaMaxWidthMobile,
    mediaTablet,
    mediaUnderTablet,
    mediaUnderTabletQuery
} from "src/styles/mediaQuery";
import {
    Section as OriginalSection,
    Inner,
    LinePoint,
    SubLine,
    TitleLine,
    VideoWrapper,
    BackgroundVideo as StyledBackgroundVideo,
} from "src/styles/common/sectionStyles";
import imgCoin01 from "src/assets/images/point_section/img_coin1.png";
import imgCoin02 from "src/assets/images/point_section/img_coin2.png";
import imgCoin03 from "src/assets/images/point_section/img_coin3.png";
import imgCoin04 from "src/assets/images/point_section/img_coin4.png";
import imgCircledBurger from "src/assets/images/point_section/img_burger_circled.png";
import imgCircledShoes from "src/assets/images/point_section/img_shoes_circled.png";
import imgCircledCake from "src/assets/images/point_section/img_cupcake_circled.png";
import imgCircledComputer from "src/assets/images/point_section/img_computer_circled.png";
import {PointSectionVideoProps} from "src/pages/section/PointSection/index";
import {motion, useInView} from "framer-motion";

const textContainerVariants = {
    initial: {
        opacity: 0,
        y: 45
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            delay:.5,
        }
    },

};
const bgVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.5,
            when: "beforeChildren",
            staggerChildren: .5,
        },
    },
};

const coinVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        duration: .3,
    },
};
interface CoinImgProps {
    src: string;
    alt?: string;
    className:string;
}

const images = [
    imgCoin01,
    imgCoin02,
    imgCoin03,
    imgCoin04
];

const CoinImg: React.FC<CoinImgProps> = ({ src, alt, className }) => {
    return (
        <CoinImgItem variants={coinVariants}>
            <img src={src} alt={alt} className={className} />
        </CoinImgItem>
    );
};

function PointSectionView({  tabletVideoSrc,defaultVideoSrc}:PointSectionVideoProps) {
    const [isLoop, setIsLoop] = useState(true);
    const sectionRef = useRef(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const inView = useInView(sectionRef, { once: true, amount: 0.3 });

    useEffect(() => {
        const mediaQuery = window.matchMedia(mediaUnderTabletQuery);

        const updateLoopState = (query: MediaQueryList | MediaQueryListEvent) => {
            const isUnderTablet = query.matches;
            setIsLoop(isUnderTablet);
        };

        updateLoopState(mediaQuery);
        const handleMediaQueryChange = (e: MediaQueryListEvent) => {
            updateLoopState(e);
        };

        mediaQuery.addEventListener('change', handleMediaQueryChange);

        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    }, []);

    useEffect(() => {
        if (inView && videoRef.current) {
            videoRef.current.play();
        }
    }, [inView]);
    return (
        <Section className="section" ref={sectionRef}>
            <ContentBg
                variants={bgVariants}
                initial="initial"
                whileInView="animate"
                viewport={{
                    once: true,
                    amount: .35,
                }}
            >
                {images.map((src, index) => (
                    <CoinImg key={index} src={src} alt={`coin-${index + 1}`} className={`coin_${index + 1}`} />
                ))}
            </ContentBg>
            <Inner>
                <ContentsWrap>
                    <Contents
                        variants={textContainerVariants}
                        initial="initial"
                        whileInView="animate"
                        viewport={{
                            once: true,
                            amount: .35,
                        }}
                    >
                        <TextWrapper>
                            <TitleLine><LinePoint className="main-color">포인트 적립</LinePoint>하면<br/>
                                경품 당첨의 행운까지!
                            </TitleLine>
                            <SubLine >참여만 해도 꾸준히 쌓이는 포인트,<br/>
                                행운경품 당첨 확률 UP!</SubLine>
                        </TextWrapper>
                        <ItemWrapper>
                            <ImgCircle>
                                <img src={imgCircledBurger} alt="" aria-hidden="true"/>
                            </ImgCircle>
                            <ImgCircle>
                                <img src={imgCircledShoes} alt="" aria-hidden="true"/>
                            </ImgCircle>
                            <ImgCircle>
                                <img src={imgCircledCake} alt="" aria-hidden="true"/>
                            </ImgCircle>
                            <ImgCircle>
                                <img src={imgCircledComputer} alt="" aria-hidden="true"/>
                            </ImgCircle>
                        </ItemWrapper>
                    </Contents>
                    <Contents>
                        <VideoWrapper>
                            <BackgroundVideo
                                ref={videoRef}
                                autoPlay={false}
                                loop={isLoop}
                                muted
                                preload="none"
                                playsInline
                                aria-hidden="true"
                            >
                                <source
                                    src={
                                        window.matchMedia(mediaUnderTabletQuery).matches
                                            ? tabletVideoSrc
                                            : defaultVideoSrc
                                    }
                                    type="video/mp4"
                                />
                            </BackgroundVideo>
                        </VideoWrapper>
                    </Contents>
                </ContentsWrap>
            </Inner>
            </Section>
    );
}

export default PointSectionView;

const Section = styled(OriginalSection)`
  position: relative; 
`
const ContentBg=styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  background-color:#fff;
`
const ContentsWrap = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  ${mediaTablet} {
    flex-flow: column;
    justify-content: center;
  }
`;
const Contents = styled(motion.div)`
  &:nth-child(1) {
    ${mediaTablet} {
      z-index: 1;
    }
  }

  &:nth-child(2) {
    position: relative;
    width: 100%;
    max-width: 940px;
    height: 882px;
    ${mediaLaptop} {
      max-width: 647px;
      height: 549px;
    }
    ${mediaTablet} {
      max-width: 830px;
      height: 778px;
    }
    ${mediaUnderTablet} {
      max-width:370px;
      height: 464px;
    }
    ${mediaMaxWidthMobile} {
      max-width:unset;
      height: 540px;
    }
  }
`;
const BackgroundVideo = styled(StyledBackgroundVideo)`
  left: 0;
  right: unset;
  margin: unset;
`

const TextWrapper = styled.div`
  ${mediaTablet} {
    text-align: center;
  }
`;

const ItemWrapper = styled.ul`
  width: 100%;
  margin-top: 61px;
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  ${mediaTablet} {
    display: none;
  }
`
const ImgCircle = styled.li`
  flex-shrink: 0;
  width: 81px;
  height:81px;
`

const CoinImgItem=styled(motion.div)` 
  .coin_1 {
    position: absolute;
    z-index: 2;
    width: 324px;
    height: 316px;
    bottom: -91px;
    left: 432px;
    ${mediaTablet} {
      top: 99px;
      bottom:unset;
      left: -229px;
    }
    ${mediaMaxWidthMobile} {
      width: 159px;
      height: 153px;
      top: 152px;
      left: -109px;
    }
    ${mediaMaxWidthMobile} {
      top: 20px;
    }
  }

  .coin_2 {
    position: absolute;
    z-index: 2;
    width: 90px;
    height: 120px;
    bottom: 98px;
    right: 236px;
    ${mediaTablet} {
      bottom: 14px;
      right: 210px;
    }
    ${mediaUnderTablet} {
      width: 45px;
      height: 60px;
      bottom: 0;
      right: 87px;
    }
    ${mediaMaxWidthMobile} {
      bottom: -30px;
      right: 40px;
    }
  }
  .coin_3 {
    position: absolute;
    z-index: 2;
    width: 189px;
    height: 202px;
    bottom: 218px;
    right: -52px;
    ${mediaTablet} {
      bottom: 180px;
      right: -100px;
    }
    ${mediaUnderTablet} {
      width: 81px;
      height: 87px;
      bottom: 178px;
      right:-33px;
    }
    ${mediaMaxWidthMobile} {
      bottom: 108px;
      right: -50px;
    }
  }
  .coin_4 {
    position: absolute;
    z-index: 2;
    width: 120px;
    height: 106px;
    top: 27px;
    right:81px;
    ${mediaTablet} {
      top: 107px;
      right:50px;
    }
    ${mediaUnderTablet} {
     display: none;
    }
  }
`